import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Link from "@amzn/meridian/link";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const ActionableMetricView = (data) => {
    const {textFont} = useDeviceLayout()

    const onMetricCountClick = () => {
        if (data.onMetricCountClick) {
            data.onMetricCountClick();
        }
    }

    return (
        <Column spacing={"small"} width={"100px"}>
            <Text type="d50">
                <Link type={"secondary"} onClick={onMetricCountClick}>{data.pickStatus.value}</Link>
            </Text>
            <Text type={textFont} color={"secondary"}>
                <FormattedMessage id={data.pickStatus.title} defaultMessage={data.pickStatus.message} />
            </Text>
        </Column>
    )
}

export default ActionableMetricView


// WEBPACK FOOTER //
// ./src/components/pickStatus/ActionableMetricView.js